import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { compose } from "redux";

import { UrlProvider } from "../../../../../api/UrlProvider";
import { ButtonWithArrow } from "../../../common/Typography";
import NoPriceAlertsIcon from "./assets/no-price-alerts.svg";
import withTranslations from "../../../../../hocs/withTranslations";

const NoPriceAlerts = ({
  title,
  description,
  showButton = false,
  buttonLabel,
  locale
}) => (
  <div className="flex flex-col align-center text-center max-w-100 mx-auto mt-10">
    <img
      className="mb-4"
      src={NoPriceAlertsIcon}
      alt=""
      width={104}
      height={104}
    />
    <strong className="text-xl.1 font-semibold line-height-130 text-black mb-4">
      {title}
    </strong>
    <p
      className={classNames("text-xs line-height-160 text-black-8", {
        "mb-6": showButton
      })}
    >
      {description}
    </p>
    {showButton ? (
      <ButtonWithArrow
        href={UrlProvider.getUrl("fe.desktopPage", { locale })}
        showArrow={false}
        withBackground
      >
        {buttonLabel}
      </ButtonWithArrow>
    ) : null}
  </div>
);

NoPriceAlerts.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  showButton: PropTypes.bool,
  buttonLabel: PropTypes.string
};

export default compose(withTranslations)(NoPriceAlerts);
